import React from 'react';
import './Footer.scss';

const Index = () => (
	<section className="layout__footer" aria-label="Footer">
		<footer>
		</footer>
	</section>
);

export default Index;
